import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { CustomerTransferResolver } from './resolvers/customer-transfer.resolver';
import { OrderContainerViewComponent } from './views/order-container-view/order-container-view.component';
import { OrderProductNotFoundViewComponent } from './views/order-product-not-found-view/order-product-not-found-view.component';
import { OrderSuccessViewComponent } from './views/order-success-view/order-success-view.component';
import { ProductDataResolver } from './resolvers/product-data.resolver';
import { TitlesResolver } from './resolvers/titles.resolver';
import { productAccessGuard } from './guards/product-access.guard';
import { validProductGuard } from './guards/valid-product.guard';

const routes: Routes = [
    {
        path: 'bestellung-abgeschlossen',
        component: OrderSuccessViewComponent,
    },
    {
        path: '',
        component: OrderProductNotFoundViewComponent,
    },
    {
        path: 'tablet-schueler',
        redirectTo: 'tablet-versicherung-plus',
    },
    {
        path: 'tablet-plus',
        redirectTo: 'tablet-versicherung-plus',
    },
    {
        path: 'tablet-plus-j',
        redirectTo: 'tablet-versicherung-plus-j',
    },
    {
        path: ':productSlugOrId',
        redirectTo: ':productSlugOrId/',
    },
    {
        path: ':productSlugOrId/:step',
        component: OrderContainerViewComponent,
        canActivate: [productAccessGuard, validProductGuard],
        canActivateChild: [productAccessGuard, validProductGuard],
        resolve: {
            customer: CustomerTransferResolver,
            productData: ProductDataResolver,
            titles: TitlesResolver,
        },
    },
];

@NgModule({
    imports: [RouterModule.forChild(routes)],
})
export class OrderRoutingModule {}

export const routingComponents = [
    OrderSuccessViewComponent,
    OrderContainerViewComponent,
    OrderProductNotFoundViewComponent,
];
